import * as React from 'react'

import {
  LIST_EXTENSION,
  useFormattableI18nProperty,
  useSiteConfig,
  useSiteDefinition,
} from '@thg-commerce/enterprise-core'
import { mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { BrandLogo, BrandSize } from '@thg-commerce/gravity-elements'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'

import { useProductPage } from '../../context'

const Title = styled.h1<{ textStyle?: TextStyling }>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'large1',
      props.textStyle?.style || 'alternate',
    )};

  padding: ${spacing(0.5)} 0 ${spacing(1)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(1)} 0;
  }
`

const StyledProductTitleAndLogoWrapper = styled.div`
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: none;
  }
  padding: 0 ${spacing(1)};
  margin: ${spacing(1)} ${spacing(1)} 0;
`

export const ProductTitleAndLogo = ({
  textStyle,
}: {
  textStyle?: TextStyling
}) => {
  const i18nText = {
    brandLogoLabel: useFormattableI18nProperty('product.brand.logo.label'),
    brandUrl: useFormattableI18nProperty('product.brand.logo.url'),
  }
  const { product, selectedVariant } = useProductPage()
  const { originUrl } = useSiteDefinition()
  const {
    enableProductBrandPageLink,
    showBrandLogoOnProductPage,
  } = useSiteConfig()

  const variant = selectedVariant ? selectedVariant : product

  const brandLogoProps = product?.brand?.imageUrl &&
    product?.brand?.name &&
    showBrandLogoOnProductPage && {
      brandLabel: i18nText.brandLogoLabel(product.brand.name),
      imageUrl: product.brand.imageUrl,
      brandSize: BrandSize.LARGE,
      ...(enableProductBrandPageLink
        ? {
            brandUrl: product.brand.page?.path
              ? `${product.brand.page.path}${LIST_EXTENSION}`
              : i18nText.brandUrl([
                  originUrl,
                  `${product.brand.name
                    .replace(/\s/g, '-')
                    .replace('.', '')
                    .toLowerCase()}${LIST_EXTENSION}`,
                ]),
          }
        : {}),
    }

  return (
    <StyledProductTitleAndLogoWrapper data-testid="product-title-logo-wrapper">
      {brandLogoProps && <BrandLogo {...brandLogoProps} />}
      <Title textStyle={textStyle}>{variant?.title}</Title>
    </StyledProductTitleAndLogoWrapper>
  )
}
